<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <b-card>
                <div class="d-flex align-items-center justify-content-between">
                    <h4 class="mb-0"><i class="fa fa-list mr-2" />Surat Perintah Kerja</h4>
                    <div class="text-right">
                        <router-link v-if="isAddAllowed" to="/spk/create">
                            <b-button variant="dark">
                                <i class="fa fa-plus mr-2" />SPK Baru
                            </b-button>
                        </router-link>
                    </div>
                </div>
                <hr />
                <b-row>
                    <b-col md="3">
                        <b-form-group label="No. SPK">
                            <b-form-input v-model="filter.no" type="search" @keydown.enter="getItems()" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="No. SN">
                            <b-form-input v-model="filter.sn" type="search" @keydown.enter="getItems()" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Status SPK">
                            <b-form-select v-model="filter.status" :options="optStatus">
                                <template v-slot:first>
                                    <b-form-select-option value=-1>Semua</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Kategori">
                            <b-form-select v-model="filter.category" :options="optCategory">
                                <template v-slot:first>
                                    <b-form-select-option value=-1>Semua</b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col md="3">
                        <b-form-group label="Dari Tanggal Pembuatan">
                            <b-form-input v-model="filter.start" type="date" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Sampai Tanggal Pembuatan">
                            <b-form-input v-model="filter.end" type="date" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Dari Tanggal Selesai">
                            <b-form-input v-model="filter.startFinish" type="date" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Sampai Tanggal Selesai">
                            <b-form-input v-model="filter.endFinish" type="date" />
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="BOM">
                            <b-form-select v-model="filter.bom">
                                <b-form-select-option value=-1>Semua</b-form-select-option>
                                <b-form-select-option value=1>Outstanding / Ready</b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="SPB">
                            <b-form-select v-model="filter.spb">
                                <b-form-select-option value=-1>Semua</b-form-select-option>
                                <b-form-select-option value=1>Outstanding</b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Alur Kerja">
                            <b-form-select v-model="filter.flow">
                                <b-form-select-option value=-1>Semua</b-form-select-option>
                                <b-form-select-option :value="$enums.SpkFlow.REPAIR">REPAIR</b-form-select-option>
                                <b-form-select-option :value="$enums.SpkFlow.SCRAP">SCRAP</b-form-select-option>
                                <b-form-select-option :value="$enums.SpkFlow.QC">QC</b-form-select-option>
                                <b-form-select-option :value="$enums.SpkFlow.DISMANTLE">DISMANTLE</b-form-select-option>
                                <b-form-select-option :value="$enums.SpkFlow.ASSEMBLY">ASSEMBLY</b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col md="3">
                        <b-form-group label="Jenis SPK">
                            <b-form-select v-model="filter.workType">
                                <b-form-select-option value=-1>Semua</b-form-select-option>
                                <b-form-select-option :value="$enums.SpkWorkType.REPAIR">REPAIR</b-form-select-option>
                                <b-form-select-option :value="$enums.SpkWorkType.QC">QC</b-form-select-option>
                                <b-form-select-option :value="$enums.SpkWorkType.DISMANTLE">DISMANTLE</b-form-select-option>
                                <b-form-select-option :value="$enums.SpkWorkType.ASSEMBLY">ASSEMBLY</b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <div class="search-wrapper d-flex align-items-center mb-3">
                    <b-button variant="primary" class="mr-2" @click="getItems">
                        <i class="fa fa-search mr-2" /> Search
                    </b-button>
                    <b-button variant="danger" @click="resetSearch">
                        <i class="fa fa-times mr-2" /> Reset Search
                    </b-button>
                    <b-button variant="success" class="ml-2" @click="openDownloadModal">
                        <i class="fa fa-download mr-2" /> Download Excel
                    </b-button>
                </div>
                <b-table bordered hover show-empty
                    :busy="isBusy"
                    :items="items"
                    :fields="fields"
                    responsive class="mb-3"
                >
                    <template v-slot:empty>
                        Tidak ada SPK.
                    </template>
                    <template v-slot:cell(no)="row">
                        {{ row.item.no }}
                        <div class="text-muted small font-weight-bold">
                            <span v-if="row.item.flow == $enums.SpkFlow.REPAIR">REPAIR</span>
                            <span v-else-if="row.item.flow == $enums.SpkFlow.SCRAP">
                                <span v-if="row.item.flowResult == $enums.SpkFlowResult.RTS">SCRAP - INOPERATIVE</span>
                                <span v-else-if="row.item.flowResult == $enums.SpkFlowResult.JUNK">SCRAP - JUNK</span>
                            </span>
                            <span v-else-if="row.item.flow == $enums.SpkFlow.QC">QC</span>
                            <span v-else-if="row.item.flow == $enums.SpkFlow.DISMANTLE">
                                DISMANTLE
                                <span v-if="row.item.flowResult == $enums.SpkFlowResult.RTS">- INOPERATIVE</span>
                                <span v-else-if="row.item.flowResult == $enums.SpkFlowResult.JUNK">- JUNK</span>
                                <span v-else-if="row.item.flowResult == $enums.SpkFlowResult.CONTINUE_ASSY">- LANJUT ASSEMBLY</span>
                            </span>
                            <span v-else-if="row.item.flow == $enums.SpkFlow.ASSEMBLY">ASSEMBLY</span>
                            <span v-else>-</span>
                        </div>
                    </template>
                    <template v-slot:cell(status)="row">
                        <b-badge :variant="parseStatusBadge(row.item.status)">{{ row.item.status }}</b-badge>
                        <div v-if="row.item.bomOuts != 0" class="small font-weight-bold">
                            BOM: {{ row.item.bomOuts }} Outs. <span v-if="row.item.bomReady != 0">{{ row.item.bomReady }} Ready.</span>
                        </div>
                        <div v-for="spb in row.item.spb" v-bind:key="spb" class="text-muted small">
                            {{ spb }}
                        </div>
                    </template>
                    <template v-slot:cell(unit)="row">
                        {{ row.item.sn }}
                        <div class="small text-muted">{{ row.item.type }} {{ row.item.search1 != null ? " - " + row.item.search1 : "" }}</div>
                    </template>
                    <template v-slot:cell(createdAt)="row">
                        {{ $helper.parseDate(row.item.createdAt) }}
                        <div class="small text-muted">{{ $helper.parseHourMinute(row.item.createdAt) }}</div>
                    </template>
                    <template v-slot:cell(finishedAt)="row">
                        {{ $helper.parseDate(row.item.finishedAt) }}
                        <div class="small text-muted">{{ $helper.parseHourMinute(row.item.finishedAt) }}</div>
                    </template>
                    <template v-slot:cell(action)="row">
                        <router-link :to="'/spk/' + row.item.id">
                            <b-button size="sm" variant="primary" v-b-tooltip.hover.top title="Detail">
                                <i class="fa fa-fw fa-search" />
                            </b-button>
                        </router-link>
                    </template>
                </b-table>
                <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                    <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" />
                    <b-pagination class="mb-0"
                        v-model="currentPage"
                        :totalRows="totalRows"
                        :per-page="perPage"
                        @change="onPageChange"
                    />
                </div>
            </b-card>
        </div>
        <b-modal id="modal-download-excel" title="Download Excel" centered no-close-on-backdrop no-close-on-esc hide-footer>
            <div v-if="downloadStatus == 1" class="text-center">
                <b-spinner class="loading-spinner" variant="dark" />
                <div class="mt-2">Mempersiapkan file, mohon menunggu...</div>
            </div>
            <div v-else-if="downloadStatus == 2">
                <div class="mb-2">File siap didownload, silahkan klik tombol dibawah ini:</div>
                <a :href="downloadPath" download>
                    <b-button variant="primary">
                        <i class="fa fa-download mr-2" />Download Excel
                    </b-button>
                </a>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'spk-list',
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,
            show: 10,

            downloadStatus: 0,
            downloadPath: "",

            filter: {
                no: "",
                sn: "",
                status: -1,
                category: -1,
                bom: -1,
                spb: -1,
                start: "",
                end: "",
                startFinish: "",
                endFinish: "",
                flow: -1,
                workType: -1
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "no", label: "No. SPK & Alur Kerja" },
                { key: "category", label: "Kategori" },
                { key: "unit", label: "Unit" },
                { key: "status", label: "Status / BOM / SPB" },
                { key: "createdAt", label: "Tanggal Pembuatan" },
                { key: "finishedAt", label: "Tanggal Selesai" },
                { key: "action", label: "Aksi"},
            ],

            items: [],
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            totalPages: 0,

            optCategory: [],
            optStatus: [
                { value: 1, text: "BARU" },
                { value: 2, text: "WAIT JOB DESC" },
                // { value: 3, text: "WAIT ACC BOM" },
                // { value: 4, text: "WAIT LOG" },
                { value: 5, text: "IN PROCESS" },
                { value: 6, text: "WAIT APPR" },
                { value: 7, text: "WAIT RETURN" },
                { value: 8, text: "CLOSED" },
                { value: 9, text: "WAIT SCRAP APPROVAL" },
                { value: 10, text: "WAIT SCRAP RECEIVED" },
                { value: 0, text: "BATAL" }
            ]

        }
    },
    computed: {

        isAddAllowed() {
            return [0, 7, 8].includes(this.$helper.getRoleId())
        }

    },
    methods: {

        init() {

            this.initStatus = 0

            let getItems = this.getItems()

            let getCategory = this.$axios.get("plan/get-category").then(res => {
                this.optCategory = res.data.map(it => { return { value: it.id, text: it.name } })
            })

            Promise.all([getItems, getCategory]).then(res => {
                this.initStatus = 1
            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.initStatus = -1
            })

        },

        buildFilterParam() {

            let param = ""

            if(!this.$helper.isBlank(this.filter.no)) {
                param += "&filterNo=" + this.filter.no
            }

            if(!this.$helper.isBlank(this.filter.sn)) {
                param += "&filterSn=" + this.filter.sn
            }

            if(this.filter.status != -1) {
                param += "&filterStatus=" + this.filter.status
            }

            if(this.filter.category != -1) {
                param += "&filterCategory=" + this.filter.category
            }

            if(!this.$helper.isBlank(this.filter.start)) {
                param += "&filterStart=" + this.filter.start
            }

            if(!this.$helper.isBlank(this.filter.end)) {
                param += "&filterEnd=" + this.filter.end
            }

            if(!this.$helper.isBlank(this.filter.startFinish)) {
                param += "&filterStartFinish=" + this.filter.startFinish
            }

            if(!this.$helper.isBlank(this.filter.endFinish)) {
                param += "&filterEndFinish=" + this.filter.endFinish
            }

            if(this.filter.bom == 1) {
                param += "&filterBom=true"
            }

            if(this.filter.spb == 1) {
                param += "&filterSpb=true"
            }

            if(this.filter.flow != -1) {
                param += "&filterFlow=" + this.filter.flow
            }

            if(this.filter.workType != -1) {
                param += "&filterWorkType=" + this.filter.workType
            }

            return param

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage - 1, this.perPage)
            param += this.buildFilterParam()

            // Execute
            return this.$axios.get("spk/" + param).then(res => {

                this.items = res.data.data
                this.totalRows = res.data.total

            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        openDownloadModal() {

            this.downloadStatus = 1
            this.downloadPath = ""

            this.$bvModal.show("modal-download-excel")

            this.$axios.get("spk/download/?" + this.buildFilterParam().substring(1)).then(res => {

                this.downloadPath = this.$BASE_FILE_PATH + res.data
                this.downloadStatus = 2

            })
            .catch(error => {
                this.$helper.parseError(this, error)
                this.$bvModal.hide("modal-download-excel")
            })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems()
        },

        onPageChange(newPage) {
            this.getItems(newPage)
        },

        resetSearch() {

            this.filter.no = ""
            this.filter.sn = ""
            this.filter.category = -1
            this.filter.status = -1
            this.filter.bom = -1
            this.filter.start = ""
            this.filter.end = ""
            this.filter.spb = -1
            this.filter.flow = -1
            this.filter.workType = -1
            this.getItems()

        },

        parseStatusBadge(status) {

            switch(status) {
                case "BATAL": return "danger"
                case "BARU": return "primary"
                case "CLOSED": return "success"
                case "IN PROCESS": return "warning"
                default: return "dark"
            }

        }

    },
    created() {
        this.init()
    }
}
</script>
